import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { useStore as useAuthStore } from '../../stores/auth';
import { useStore as useAuthV2Store } from '../../stores/v2/auth';

export const authHandler = (config: AxiosRequestConfig) => {
  const authStore = useAuthStore();
  const authV2Store = useAuthV2Store();

  // Prefer v2 store if token is available
  if (authV2Store.tok !== '') {
    config.headers['x-token'] = authV2Store.tok;
    config.headers['x-customerId'] = authV2Store.sapCustomerId;
    if (authV2Store.endCustomerId !== '') {
      config.headers['x-endCustomerId'] = authV2Store.endCustomerId;
    }

    return config;
  }

  config.headers['x-token'] = authStore.tok;
  config.headers['x-customerId'] = authStore.sapCustomerId;
  if (authStore.endCustomerId !== '') {
    config.headers['x-endCustomerId'] = authStore.endCustomerId;
  }
  return config;
};

export const validTokenHandler = (response: AxiosResponse) => {
  const authStore = useAuthStore();
  authStore.setIsTokValid(true);
  return response;
};

export const invalidTokenHandler = (error: AxiosError) => {
  const authStore = useAuthStore();
  if (error.response?.status === 401) {
    authStore.setIsTokValid(false);
  } else {
    authStore.setIsTokValid(true);
  }
  return Promise.reject(error);
};
